module.exports = __webpack_public_path__ + "static/media/galerija_2014 (22).6ec19273.jpg";